// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solutionsContainer_PiCaH {
  width: 100%;
  display: none;
  background-color: var(--white-background);
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 1;
  overflow: scroll;
  gap: 30px;
  position: fixed;
  top: 50px;
  right: 0px;
  @media (width<=1000px) {
    top: 0;
  }
  @media (width>=1000px) {
    &:hover {
      display: flex;
    }
  }

  .container_Pzjxj {
    height: calc(100vh - 50px);
    overflow: scroll;
    margin: 0 auto;
    @media (width<=1000px) {
      height: 100vh;
    }
  }

  .content_ypJJK {
    margin: 0px auto;
    width: 97vw;
    background-color: #f5f5f574;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    .headerSolution_k99VJ{
      margin: 10px 0;
      display: flex;
      align-items: center;
      gap: 10px;

      span {
        display: inline-block;
        color: #737373;
      }

      >p {
        margin: 0;
        color: #666666;
        background-color: #2222223c;
        padding: 6px 8px ;
        border-radius: 999px;
      }

      @media (width<=528px) {
        flex-direction: column;
      }
    }
  }

  .solutionCard_J8qHb {
    background-color: var(--f1-background);
    padding: 10px;
    border-radius: 8px;
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;

    &:hover{
      .infoSolution_ILY86{
        h3{
          text-transform: capitalize;
        }
      }
    }

          button{
            background-color: #E7E7E7;
            color: var(--_71717a-color);
          }

          &:hover{
            button{
              background-color: var(--_10a37f-background);
              color: var(--white-background);
            }
          }

    .infoSolution_ILY86 {
      display: flex;
      align-items: center;
      gap: 10px;

      svg {
        width: 20px;
        height: 20px;
      }
      h3 {
        margin: 0;
        color: #09090b;
        font-weight: 400;
        font-size: 16px;
        text-transform: lowercase;
      }
      .textSolutions_yF9Z6{
        text-transform: capitalize;
      }
    }

    p {
      font-size: 13px;
      margin: 0px 0px 4px;
    }
  }

  .solutionsList__gyqy {
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 640px) {
    .solutionsList__gyqy {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (min-width: 768px) {
    .solutionsList__gyqy {
      grid-template-columns: repeat(3,
          1fr);
      &.bottom_b7NxX{
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }

  @media (min-width: 1024px) {
    .solutionsList__gyqy {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Navbar/Solutions/Solutions.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,SAAS;EACT,UAAU;EACV;IACE,MAAM;EACR;EACA;IACE;MACE,aAAa;IACf;EACF;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd;MACE,aAAa;IACf;EACF;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB;MACE,cAAc;MACd,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;QACE,qBAAqB;QACrB,cAAc;MAChB;;MAEA;QACE,SAAS;QACT,cAAc;QACd,2BAA2B;QAC3B,iBAAiB;QACjB,oBAAoB;MACtB;;MAEA;QACE,sBAAsB;MACxB;IACF;EACF;;EAEA;IACE,sCAAsC;IACtC,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;;IAER;MACE;QACE;UACE,0BAA0B;QAC5B;MACF;IACF;;UAEM;YACE,yBAAyB;YACzB,2BAA2B;UAC7B;;UAEA;YACE;cACE,2CAA2C;cAC3C,8BAA8B;YAChC;UACF;;IAEN;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;;MAET;QACE,WAAW;QACX,YAAY;MACd;MACA;QACE,SAAS;QACT,cAAc;QACd,gBAAgB;QAChB,eAAe;QACf,yBAAyB;MAC3B;MACA;QACE,0BAA0B;MAC5B;IACF;;IAEA;MACE,eAAe;MACf,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,SAAS;IACT,qCAAqC;EACvC;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;;EAEA;IACE;MACE;cACQ;MACR;QACE,qCAAqC;MACvC;IACF;EACF;;EAEA;IACE;MACE,qCAAqC;IACvC;EACF;AACF","sourcesContent":[".solutionsContainer {\n  width: 100%;\n  display: none;\n  background-color: var(--white-background);\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 1;\n  overflow: scroll;\n  gap: 30px;\n  position: fixed;\n  top: 50px;\n  right: 0px;\n  @media (width<=1000px) {\n    top: 0;\n  }\n  @media (width>=1000px) {\n    &:hover {\n      display: flex;\n    }\n  }\n\n  .container {\n    height: calc(100vh - 50px);\n    overflow: scroll;\n    margin: 0 auto;\n    @media (width<=1000px) {\n      height: 100vh;\n    }\n  }\n\n  .content {\n    margin: 0px auto;\n    width: 97vw;\n    background-color: #f5f5f574;\n    padding: 10px;\n    border-radius: 8px;\n    box-sizing: border-box;\n    .headerSolution{\n      margin: 10px 0;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      span {\n        display: inline-block;\n        color: #737373;\n      }\n\n      >p {\n        margin: 0;\n        color: #666666;\n        background-color: #2222223c;\n        padding: 6px 8px ;\n        border-radius: 999px;\n      }\n\n      @media (width<=528px) {\n        flex-direction: column;\n      }\n    }\n  }\n\n  .solutionCard {\n    background-color: var(--f1-background);\n    padding: 10px;\n    border-radius: 8px;\n    display: inline-flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n\n    &:hover{\n      .infoSolution{\n        h3{\n          text-transform: capitalize;\n        }\n      }\n    }\n\n          button{\n            background-color: #E7E7E7;\n            color: var(--_71717a-color);\n          }\n\n          &:hover{\n            button{\n              background-color: var(--_10a37f-background);\n              color: var(--white-background);\n            }\n          }\n\n    .infoSolution {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n\n      svg {\n        width: 20px;\n        height: 20px;\n      }\n      h3 {\n        margin: 0;\n        color: #09090b;\n        font-weight: 400;\n        font-size: 16px;\n        text-transform: lowercase;\n      }\n      .textSolutions{\n        text-transform: capitalize;\n      }\n    }\n\n    p {\n      font-size: 13px;\n      margin: 0px 0px 4px;\n    }\n  }\n\n  .solutionsList {\n    display: grid;\n    gap: 10px;\n    grid-template-columns: repeat(1, 1fr);\n  }\n\n  @media (min-width: 640px) {\n    .solutionsList {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n\n  @media (min-width: 768px) {\n    .solutionsList {\n      grid-template-columns: repeat(3,\n          1fr);\n      &.bottom{\n        grid-template-columns: repeat(2, 1fr);\n      }\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .solutionsList {\n      grid-template-columns: repeat(4, 1fr);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"solutionsContainer": `solutionsContainer_PiCaH`,
	"container": `container_Pzjxj`,
	"content": `content_ypJJK`,
	"headerSolution": `headerSolution_k99VJ`,
	"solutionCard": `solutionCard_J8qHb`,
	"infoSolution": `infoSolution_ILY86`,
	"textSolutions": `textSolutions_yF9Z6`,
	"solutionsList": `solutionsList__gyqy`,
	"bottom": `bottom_b7NxX`
};
export default ___CSS_LOADER_EXPORT___;
